import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import StandardTextField from "components/general/StandardTextField";
import { forwardRef, useState } from "react";
import { buildTestId } from "helpers/testId";

/**
 * DOM contract: `data-testid` reaches the `<input>` through
 * `StandardTextField`; the reveal toggle is `${data-testid}-toggle`.
 */
const PasswordTextField = forwardRef((props: any, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const togglePassword = () => setShowPassword(!showPassword);
  const {
    startIcon,
    endIcon,
    NewDesign,
    size,
    margin,
    showPasswordIcon,
    "data-testid": testId,
    ...other
  } = props;

  return (
    <StandardTextField
      margin={margin}
      size={size}
      ref={ref}
      {...other}
      data-testid={testId}
      type={showPassword ? "text" : "password"}
      startIcon={startIcon}
      endIcon={
        showPasswordIcon ? (
          <div aria-label="toggle password visibility">
            <IconButton
              onClick={togglePassword}
              onMouseDown={togglePassword}
              data-testid={buildTestId(testId, "toggle")}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </div>
        ) : null
      }
    />
  );
});
export default PasswordTextField;
